export const embargoHint =
    'If an embargo date is set here, Vivli will make the study available for ' +
    'researchers to request, but the data itself will not be provided until the embargo date has ' +
    'passed.  This might be necessary, for example, if the data itself cannot be provided until the ' +
    'results of the study are published.';
